import { resolveAuth0Client } from './client';
import {
  getSessionFromAuth0,
  waitForAuth0ToSettle,
  type Auth0SessionTokens,
} from './session-token-loader';
import type { Auth0ClientLike } from '../session/types';

export type Auth0SessionRequest = {
  auth0Client: Auth0ClientLike;
  freshAuth0Token?: boolean;
  organization?: string | null;
  timeoutMs?: number;
};

export type Auth0Gateway = {
  resolveAuth0Client: (auth0Client?: Auth0ClientLike | null) => Auth0ClientLike | null;
  getSessionFromAuth0: (request: Auth0SessionRequest) => Promise<Auth0SessionTokens>;
  waitForAuth0ToSettle: (auth0Client: Auth0ClientLike | null, timeoutMs?: number) => Promise<void>;
};

export const createAuth0Gateway = (): Auth0Gateway => {
  return {
    resolveAuth0Client,
    getSessionFromAuth0,
    waitForAuth0ToSettle,
  };
};
